import { Switch } from "@ezmid/components-library";
import {
  Controller,
  FieldValues,
  Control,
  Path,
  RegisterOptions,
} from "react-hook-form";

interface SwitchFieldProps<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
  rules?: RegisterOptions<T>;
  label?: string;
  variant?: "red" | "green" | "blue";
}

export function SwitchField<T extends FieldValues>({
  control,
  name,
  rules,
  label,
  variant = "green",
}: SwitchFieldProps<T>) {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, value } }) => {
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            {label && (
              <label
                htmlFor={name}
                style={{ fontSize: "14px", fontWeight: 500 }}
              >
                {label}
              </label>
            )}
            <Switch
              id={name}
              isChecked={!!value}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                onChange(e.target.checked)
              }
              variant={variant}
              label=""
            />
          </div>
        );
      }}
    />
  );
}
